import { Reveal, SectionHeading } from "@/components/Reveal";

const STEPS = [
  {
    num: "01",
    title: "Vehicle Audit",
    desc: "We inspect your fuse box, battery health and trim layout, then confirm the cleanest cable path for your exact model.",
  },
  {
    num: "02",
    title: "Concealed Routing",
    desc: "Every cable disappears behind the headliner, A-pillar and dash trims. No dangling wires, no suction-cup clutter.",
  },
  {
    num: "03",
    title: "Smart Fuse Tap",
    desc: "OEM-safe fuse tapping with a hardwire kit and voltage cut-off — parking mode without battery drain.",
  },
  {
    num: "04",
    title: "Calibration & Handover",
    desc: "Lens angle calibration, app pairing on your phone and a full parking-mode walkthrough before we leave.",
  },
];

const Process = () => (
  <section id="process" data-testid="process-section" className="relative border-y border-white/10 bg-carbon/40">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32">
      <SectionHeading eyebrow="How it works" title="Fitted in four moves" testId="process-heading" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-xl overflow-hidden">
        {STEPS.map((step, i) => (
          <Reveal key={step.num} delay={i * 0.12} className="bg-obsidian">
            <div data-testid={`process-step-${i + 1}`} className="group h-full p-7 sm:p-8 hover:bg-carbon transition-colors duration-500">
              <span className="font-display font-black text-5xl text-outline group-hover:text-sky-500 group-hover:[-webkit-text-stroke:0px] transition-all duration-500">
                {step.num}
              </span>
              <h3 className="mt-6 font-display font-bold uppercase tracking-wide text-xl text-sky-400">
                {step.title}
              </h3>
              <p className="mt-3 text-sm text-gray-400 leading-relaxed">{step.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-8 font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-gray-500" data-testid="process-note">
          Average dual-channel install: 60–90 minutes — at your home, your workplace, or our fully equipped workshop in Maddington
        </p>
      </Reveal>
    </div>
  </section>
);

export default Process;
